import { gql } from '@apollo/client';

export const ParagraphInfolinoContactFragment = gql`
  fragment ParagraphInfolinoContactFragment on ParagraphInfolinoContact {
    id
  }
`;
